import Image from 'next/image'

import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import Star from '@/assets/img/Star.png'
import { AppButton } from '@/components/shared/button'

type Props = {
  onClose: () => void
}

const FeedbackCompletedContent = ({ onClose }: Props) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  return (
    <div className="flex flex-col gap-20 xs:grow">
      <div className="xs:flex xs:grow xs:flex-col xs:justify-center">
        <div className="flex justify-center gap-12">
          <Image src={Star.src} alt="star" width={140} height={140} />
        </div>

        <div className="mt-20 w-full">
          <p className="text-center text-grey-70 text-20 xs:text-18">
            Спасибо вам за обратную связь. <br /> Для нас это очень важно!
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-12">
        <AppButton
          variant="secondary"
          size={isMobileScreen ? 'small' : 'large'}
          fluid
          onClick={onClose}
        >
          Понятно
        </AppButton>
      </div>
    </div>
  )
}

export { FeedbackCompletedContent }
